// extracted by mini-css-extract-plugin
export var actions = "_1e-0";
export var actionsContainer = "_1e-7";
export var border = "_1e-1";
export var childFullHeight = "_1e-f";
export var collapse = "_1e-2";
export var content = "_1e-a";
export var contentChild = "_1e-e";
export var fullscreen = "_1e-c";
export var hasLeftRadius = "_1e-k";
export var headerContainer = "_1e-3";
export var headerRow = "_1e-5";
export var hidePadding = "_1e-b";
export var navCollapsedGap = "_1e-l";
export var noScrollX = "_1e-m";
export var noScrollY = "_1e-n";
export var noTopPadding = "_1e-i";
export var optOutTopPadding = "_1e-d";
export var pageMain = "_1e-j";
export var pageOuter = "_1e-g";
export var pagePadding = "_1e-8";
export var pageScroll = "_1e-9";
export var profile = "_1e-o";
export var profileContainer = "_1e-p";
export var profileImage = "_1e-q";
export var profileMain = "_1e-r";
export var profileSubtitle = "_1e-t";
export var profileTitle = "_1e-s";
export var showLeftPadding = "_1e-h";
export var tabsPortalSlot = "_1e-6";
export var tabsWrapper = "_1e-4";
export var title = "_1e-u";